var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('p',[_vm._v(_vm._s(_vm.params.value.name_ja || _vm.params.value.name_en))])])}
var staticRenderFns = []

export { render, staticRenderFns }